import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { OutlineActionButton, ActionButtonBadge } from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import {
  PurchaseStyles,
} from '../purchase/Purchase.styles';
import {
  ButtonSpinner,
  ConfirmCard,
  DocsCard,
  DocsFooter,
  DocsGrid,
  DocsHeader,
  DocsTitle,
  Stack,
  StepBadge,
  SubmitDocsButton,
} from '../purchase/PurchaseV2.styles';
import { SaveBox } from '../purchase/common/SaveBox';
import NonSignableDocumentComponent from '../purchase/common/NonSignableDocumentComponent';
import DocumentsResubmissionWarning from '../purchase/common/DocumentsResubmissionWarning';
import WaitingForPaymentStatusV2 from '../../common/components/redesignComponents/Purchase/WaitingForPaymentStatusV2';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import {
  confirmAlert,
  generalAlertError,
  generalAlertSuccess,
} from '../../common/utils/alerts';

import axe from '../../services/axios-client/axiosClient';
import {
  apiDownloadDocument,
  deleteDocument,
} from '../../services/axios-client/axeCommons';
import BrokeraggioComponent from '../../common/components/redesignComponents/Purchase/BrokeraggioComponent';
import {
  condominioGetBackofficeUsers,
  purchaseInsuranceRequest,
  resetCondominioPurchase,
  updateBrokerageCondominio,
} from '../../features/purchases/purchasesActions';
import InfoBoxCondominio from '../../common/components/redesignComponents/Purchase/common/InfoBoxCondominio';
// import CompletedScreenCondominio from './CompletedScreenCondominio';
import CompletedScreen from '../../common/components/redesignComponents/Purchase/CompletedScreen';
import SentToCompanyAlert from '../purchase/SentToCompanyAlert';
import ModificaDatiComponent from '../../common/components/elements/ModificaDatiComponent';
import KoStatusAlert from '../purchase/KoStatusAlert';
import PendingIssuanceAlert from '../purchase/PendingIssuanceAlert';
import { purchase_statues } from '../../common/constants';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';

function PurchaseCondominioRequest() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const [loadingDocuments, setLoadingDocuments] = useState(false);

  const state = useSelector((store) => store.purchases.condominio);
  const {
    loading,
    quote,
    insuranceRequest,
    quoteStatus,
    backofficeUsers,
    rc_quotation,
    nonSignableDocs,
    risk_quotations,
    thread,
  } = state;

  const [supportMessage, setSupportMessage] = useState({
    subject: '',
    request_id: '',
    body: '',
    recipient: '',
  });

  const [showConversationModal, setShowConversationModal] = useState(false);

  const collectQuoteData = async () => {
    purchaseInsuranceRequest(requestToken, 'condominio', setSupportMessage);
  };

  const silentRefresh = () => purchaseInsuranceRequest(requestToken, 'condominio', setSupportMessage, navigate, false);

  const checkDocuments = async () => {
    if (
      insuranceRequest.documents
      && insuranceRequest.documents.filter((doc) => doc.is_uploaded_valid == 0)
        .length > 0
    ) {
      generalAlertError('Elimina i documenti non validi prima di procedere!');
      return;
    }

    setLoadingDocuments(true);
    try {
      const response = await axe.post(
        `insurance-request/check-insurance-documents/${insuranceRequest.id}`,
      );

      if (
        response.status === 400
        && response.data?.data?.redirect_user === false
      ) {
        generalAlertError('Devi Caricare Tutti i Documenti Obbligatori!');
        setLoadingDocuments(false);
        return;
      }

      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    } catch (error) {
      setLoadingDocuments(false);
      generalAlertError('Errore Interno');
    }
  };

  const downloadDocument = async (documentId) => {
    const response = await apiDownloadDocument(documentId);

    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const removeDocument = async (documentId) => {
    try {
      const response = await deleteDocument(documentId);

      if (response.status === 200) {
        collectQuoteData();
      }
    } catch (err) {
      // console.error(err);
    }
  };

  const sendBrokerageAmount = async (amount, skipCollect = false) => {
    if (skipCollect) {
      await updateBrokerageCondominio(
        rc_quotation.id,
        amount,
        () => { },
        skipCollect,
      );
    } else {
      await updateBrokerageCondominio(
        rc_quotation.id,
        amount,
        collectQuoteData,
        skipCollect,
      );
    }
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (rc_quotation !== null) {
      quoteInProccessAmount = parseFloat(rc_quotation.amount);
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount;

    return total.toFixed(2);
  };

  const agreedDocuments = async () => {
    try {
      const response = await axe.post(
        `/agree-to-upload-documents/${insuranceRequest.id}`,
        {
          agree_to_upload_document: 1,
        },
      );
      if (response.status !== 200) {
        generalAlertError('Non Accetato');
        return;
      }

      collectQuoteData();
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    collectQuoteData();
    condominioGetBackofficeUsers();
    return () => {
      resetCondominioPurchase();
    };
  }, []);

  //   //! MANUAL => 0, DIGITAL => 1
  //   const selectedMethod = async () => {
  //     professionSelectSignMethod(signMethod, rc_quotation.id, collectQuoteData);
  //   };

  //   useEffect(() => {
  //     if (signMethod !== null) {
  //       selectedMethod();
  //     }
  //   }, [signMethod]);

  useEffect(() => {
    if (insuranceRequest && insuranceRequest.redirect_user === true) {
      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    }
  }, [insuranceRequest]);

  const navigateBack = () => {
    navigate(`/quotes/condominio/${insuranceRequest.request_token}`);
  };

  // useEffect(() => {
  //   if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
  //     navigate('/quote/condominio', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, requestToken]);

  if (loading) {
    return <PageLoading />;
  }
  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_condominio_purchase"
        />
      )}
      <PurchaseStyles>
        {quoteStatus !== 7 && (
          <>
            <div className="container mt-0 d-flex gap-2 align-items-center justify-content-start mb-3">
              {![4, 6, 7].includes(quoteStatus) && (
                <ModificaDatiComponent navigateBack={navigateBack} />
              )}
            </div>
            <div className="container mt-0">
              <InfoBoxCondominio
                rc_quotation={rc_quotation}
                insuranceRequest={insuranceRequest}
                statuses={purchase_statues}
                quoteStatus={quoteStatus}
                messagesModalData={{
                  backofficeUsers,
                  setSupportMessage,
                  supportMessage,
                  collectData: collectQuoteData,
                }}
                risk_quotations={risk_quotations}
              />
              <div className="d-flex align-items-center justify-content-end mt-3">
                <OutlineActionButton
                  type="button"
                  onClick={() => {
                    setShowConversationModal(true);
                    if (thread?.unreadMessages > 0) silentRefresh();
                  }}
                >
                  <ChatIcon />
                  Contatta il Backoffice
                  {thread?.unreadMessages > 0 && (
                    <ActionButtonBadge>
                      {thread.unreadMessages}
                      <span className="visually-hidden">messaggi non letti</span>
                    </ActionButtonBadge>
                  )}
                </OutlineActionButton>
              </div>
              {quoteStatus === 1 || quoteStatus === 2 || quoteStatus === 5 ? (
                <>
                  <Stack className="documents-status-step-four">
                    <SaveBox
                      insuranceRequest={insuranceRequest}
                      quotationId={rc_quotation.id}
                      refresh={collectQuoteData}
                    />

                    <ConfirmCard className="skip-doc" $done={insuranceRequest.agree_upload_documents === 1}>
                      <p>
                        <FontAwesomeIcon
                          icon={insuranceRequest.agree_upload_documents === 1 ? faCircleCheck : faTriangleExclamation}
                        />
                        Importante
                      </p>
                      <label>
                        <input
                          type="checkbox"
                          checked={insuranceRequest.agree_upload_documents === 1}
                          disabled={insuranceRequest.agree_upload_documents === 1}
                          onClick={() => confirmAlert('', () => agreedDocuments())}
                        />
                        Dichiaro di aver adempiuto agli obblighi in ambito di consegna documentazione precontrattuale
                      </label>
                    </ConfirmCard>

                    {insuranceRequest.agree_upload_documents !== null && (
                      <DocsCard>
                        <DocumentsResubmissionWarning quoteStatus={quoteStatus} />
                        <DocsHeader>
                          <StepBadge>1</StepBadge>
                          <DocsTitle>
                            Carica i
                            {' '}
                            <b>documenti</b>
                            {' '}
                            del cliente
                          </DocsTitle>
                        </DocsHeader>
                        <DocsGrid>
                          {nonSignableDocs.map((docType, index) => (
                            <NonSignableDocumentComponent
                              key={index}
                              insuranceRequest={insuranceRequest}
                              documentType={docType}
                              downloadDocument={downloadDocument}
                              removeDocument={removeDocument}
                              rc_quotation={rc_quotation}
                              collectQuoteData={collectQuoteData}
                            />
                          ))}
                        </DocsGrid>
                        {quoteStatus !== 5 && (
                          <DocsFooter>
                            <SubmitDocsButton
                              type="button"
                              onClick={() => confirmAlert(
                                'Sei sicuro di voler procedere?',
                                () => checkDocuments(),
                              )}
                              disabled={loadingDocuments}
                            >
                              {loadingDocuments && <ButtonSpinner />}
                              Invia Documenti
                            </SubmitDocsButton>
                          </DocsFooter>
                        )}
                      </DocsCard>
                    )}
                  </Stack>
                  {/* <div className="documents-status-step-five">
                    {rc_quotation.sign_later === null && (
                      <div className="row mt-3">
                        <div className="col-12 col-xxl-12 mt-2 mt-xxl-0">
                          <SkipSignedDocs>
                            <p className="text-center">Vuoi Firmare Dopo?</p>
                            <div className="d-flex justify-content-center align-items-center gap-3">
                              <button className="btn btn-success border py-1 px-4" onClick={() => continueWithoutSignDocs()}>Si</button>
                              <button className="btn btn-danger border py-1 px-4" onClick={() => continueWithSignDocs()}>No</button>
                            </div>
                          </SkipSignedDocs>
                        </div>
                      </div>
                    )}
                    {rc_quotation.sign_later === 1 && <div className="alert alert-success mt-3 border rounded-4">Hai scelto di firmare i documenti più tardi.</div>}
                    {rc_quotation.sign_later === 0 && (
                      <div className="row mt-3">
                        <div className="col-12 col-xxl-12 mt-2 mt-xxl-0">
                          <SignatureTypeProfessione
                            quote={rc_quotation}
                            insuranceRequest={insuranceRequest}
                            collectQuoteData={collectQuoteData}
                            signableDocs={signableDocs}
                            requestedOptionalDocumentsSignable={requestedOptionalDocumentsSignable}
                          />
                        </div>
                      </div>
                    )}
                  </div> */}
                </>
              ) : (
                ''
              )}

              {quoteStatus === 1 && (
                <BrokeraggioComponent
                  rc_quotation={rc_quotation}
                  sendBrokerageAmount={sendBrokerageAmount}
                  getTotal={getTotal}
                />
              )}

              {quoteStatus === 4 && (
                <WaitingForPaymentStatusV2
                  quote={quote}
                  rc_quotation={rc_quotation}
                  risk_quotations={risk_quotations}
                  insuranceRequest={insuranceRequest}
                  collectQuoteData={collectQuoteData}
                />
              )}

              {quoteStatus === 6 && <PendingIssuanceAlert />}
              {/* {quoteStatus === 6 && (
                <div className="card-body mt-3">
                  <div className="row">
                    <div className="col-6 offset-3">
                      <div className="alert alert-success" role="alert">
                        <h4 className="alert-heading">In Attesa Emissione</h4>
                        <p>
                          Quando l'agente di backoffice carica la polizza,
                          riceverai una notifica e il contratto potrà essere
                          scaricato.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              {quoteStatus === 8 && <SentToCompanyAlert />}
              {quoteStatus === 9 && <KoStatusAlert insuranceRequest={insuranceRequest} />}
            </div>
          </>
        )}
        {quoteStatus === 7 && (
          /* <CompletedScreenCondominio
            quoteStatus={quoteStatus}
            customer={insuranceRequest.customer}
            rc_quotation={rc_quotation}
            risk_quotations={risk_quotations}
          /> */
          <CompletedScreen
            product="condominio"
            quoteStatus={quoteStatus}
            insuranceRequest={insuranceRequest}
            rc_quotation={rc_quotation}
            risk_quotations={risk_quotations}
          />
        )}
      </PurchaseStyles>
    </>
  );
}

export default PurchaseCondominioRequest;
